export function splitParagraphByLines(multiParagraph: string): string[] {
  return multiParagraph
    .split('\n')
    .map((paragraph) => paragraph)
    .filter((paragraph) => paragraph !== '');
}

export function ellipsifyText(text: string, characterCount: number): string {
  if (text.length <= characterCount) {
    return text;
  }
  return text.slice(0, characterCount) + '...';
}

export function relativePath(src: string) {
  return src.replace(/^[a-zA-Z]{3,5}:\/{2}[a-zA-Z0-9_.:-]+\//, '');
}

export function escapeSingleQuotes(src: string) {
  return src.replace(/(^|[^\\])'/g, "$1\\'");
}

export function capitalizeFirstLetter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}

export function capitalizeAllWords(string: string) {
  return string
    .split(' ')
    .map((word) => capitalizeFirstLetter(word))
    .join(' ');
}

export function toTitleCase(string: string) {
  return string
    .replace(/[-_]/g, ' ')
    .split(' ')
    .map((word) => capitalizeFirstLetter(word))
    .join(' ');
}

export function maskCharacter(str: string, mask: string, n = 1) {
  // Slice the string and replace with
  // mask then add remaining string
  return ('' + str).slice(0, -n).replace(/[^-]/g, mask) + ('' + str).slice(-n);
}
